// @ts-ignore
// @ts-nocheck
/* eslint-disable */

// DO NOT CONTINUE TO CODE IN THIS FILE
// PLEASE CONTINUE WITH THE INDIVIDUAL FUNCTIONS INSTEAD (billing-client, settings-client, ...)

// THIS FILE IS LEGACY CODE AND IS TO BE REMOVED WHEN POSSIBLE
// There are still parts of the code that are using this file (mostly in sagas)

import trueAxios from 'axios'
import io from 'socket.io-client'
import MockAxios from './mockAxios'
import {
  CampaignCodeGeneratorStructure,
  CampaignCodes,
  CampaignCodesCompressed,
  RegisterUser,
} from './api-types'
import Make from './make'
import { isLoggedIn } from './api-auth'
import { API_BASE_DOMAIN } from './constants'
// @ts-ignore
// const useMock = process.env.REACT_APP_PROD !== 'TRUE' && process.env.REACT_APP_TEST_API !== 'TRUE';
const useMock = false

let axios: any
if (useMock) {
  axios = MockAxios
} else {
  axios = trueAxios
}

// Progressively moving to separate modules rather than a class
const make = Make()

interface SaveCampaignCode extends CampaignCodes {
  landingPage: string
  trackingCode: string
}

export interface SaveCampaignCodes {
  lP: string
  action:
    | 'add-code'
    | 'add-multiple-codes'
    | 'add-code-clone'
    | ' add-multiple-codes-clone'
  cL: {
    pDfs: [string, string][]
    tC: string
  }[]
}

class ApiClient {
  public constructor() {}

  private getToken(): string | boolean {
    return make.getToken()
  }

  private setToken(token: string): void {
    // localStorage.setItem('tkn', token);
    // this.token = token;
    return make.setToken(token)
  }

  private getNoCache(endpoint: string, data = {}, options = {}): Promise<any> {
    return make.get({
      endpoint,
      data,
      options,
    })
  }

  private post(endpoint: string, data = {}, options = {}): Promise<any> {
    return make.post({
      endpoint,
      data,
      options,
    })
  }

  private delete(endpoint: string, data = {}, options = {}): Promise<any> {
    return make.delete({
      endpoint,
      data,
      options,
    })
  }

  private put(endpoint: string, data = {}, options = {}): Promise<any> {
    return make.put({
      endpoint,
      data,
      options,
    })
  }

  public async getVersion(): Promise<any> {
    const req = await axios({
      method: 'get',
      url: `/version.json`,
    })

    if (req && req.status === 200 && req.data) {
      return req.data
    }

    return false
  }

  public async login({
    email: username,
    password,
  }: {
    email: string
    password: string
  }): Promise<any> {
    const req = await make.post({
      endpoint: 'auth/login',
      data: {
        username,
        password,
      },
    })

    if (!req.success) {
      return req || false
    }

    return req
  }

  public async testAuth(): Promise<boolean> {
    // if (!this.getToken()) return false;
    const req = await isLoggedIn()

    return req
  }

  public async getGooglePermissions(state: any): Promise<boolean> {
    const req = await this.post('setup/authorize', {
      ...state,
      token: this.getToken(),
    })

    if (!req.success) {
      return false
    }

    window.location = req.res.data.GOOGLE_AUTH_URL
    return true
  }

  public async forwardOauth(get: string): Promise<any | boolean> {
    const req = await this.getNoCache(`setup/oauth2callback${get}`)
    if (!req.success) {
      return false
    }

    return req.res.data.state
  }

  public async getAuditData(): Promise<any | boolean> {
    const req = await this.getNoCache('audit')

    if (!req.success) {
      return false
    }

    return req.res.data.tableData
  }

  public async getAnomalyDataRange(
    metricID: string,
    from: string,
    to: string,
  ): Promise<any | boolean> {
    const req = await this.getNoCache(
      `explain/get-range/${metricID}/${from}/${to}`,
    )

    if (!req.success) {
      return false
    }

    return req.res
  }

  // public async getAnomalyByDateAndMetric(
  //   date: string,
  //   metric: string,
  // ): Promise<any | boolean> {
  //   const req = await this.getNoCache(
  //     `explain/get-ranked-dimensions/${date}/${metric}`,
  //   )
  //   if (!req.success) {
  //     return false
  //   }

  //   return req.res.data
  // }

  public async saveCause(
    id: string,
    date: string,
    metric: string,
    difference: number,
  ): Promise<any | boolean> {
    const req = await this.post('explain/save-cause', {
      databaseID: id,
      date,
      metric,
      difference,
    })
    if (!req.success) {
      return false
    }

    return true
  }

  public async saveAction(
    id: string,
    date: string,
    metric: string,
    difference: number,
  ): Promise<any | boolean> {
    const req = await this.post('explain/save-action', {
      databaseID: id,
      date,
      metric,
      difference,
    })
    if (!req.success) {
      return false
    }

    return true
  }

  public async getAnomalyRange(
    fromDate: string,
    toDate: string,
  ): Promise<any | boolean> {
    const req = await this.getNoCache(
      `calendar/get-anomalies/${fromDate}/${toDate}`,
    )
    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async getEventRange(
    fromDate: string,
    toDate: string,
  ): Promise<any | boolean> {
    const req = await this.getNoCache(
      `calendar/get-events/${fromDate}/${toDate}`,
    )
    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async createNewEvent(formData: any): Promise<any | boolean> {
    const req = await this.post('calendar/add-event', formData)
    if (!req.success) {
      return false
    }

    return true
  }

  public async updateEvent(formData: any): Promise<any | boolean> {
    const req = await this.put('calendar/update-event', formData)
    if (!req.success) {
      return false
    }

    return true
  }

  public async deleteEvent(eventID: {
    eventID: string
  }): Promise<any | boolean> {
    const req = await this.delete('calendar/delete-event', eventID)
    if (!req.success) {
      return false
    }

    return true
  }

  public async createNewCampaign(formData: any): Promise<any | boolean> {
    const req = await this.post('calendar/add-campaign', formData)
    if (!req.success) {
      return false
    }

    return true
  }

  public async updateCampaign(formData: any): Promise<any | boolean> {
    const req = await this.put('calendar/update-campaign', formData)
    if (!req.success) {
      return false
    }

    return true
  }

  public async deleteCampaign(eventID: {
    eventID: string
  }): Promise<any | boolean> {
    const req = await this.delete('calendar/delete-campaign', eventID)
    if (!req.success) {
      return false
    }

    return true
  }

  public async getGaCampaigns(
    fromDate: string,
    toDate: string,
  ): Promise<any | boolean> {
    const req = await this.getNoCache(
      `calendar/list-ga-campaign-names/${fromDate}/${toDate}`,
    )
    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async getCampaignRange(
    fromDate: string,
    toDate: string,
  ): Promise<any | boolean> {
    const req = await this.getNoCache(
      `calendar/get-campaigns/${fromDate}/${toDate}`,
    )
    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async getKpiMetrics(): Promise<any | boolean> {
    const req = await this.getNoCache('calendar/list-key-metrics')
    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async getKpis(
    fromDate: string,
    toDate: string,
    metricID: string,
  ): Promise<any | boolean> {
    const req = await this.getNoCache(
      `calendar/get-kpi-key-metric/${fromDate}/${toDate}/${metricID}`,
    )
    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async getGoalMetrics(): Promise<any | boolean> {
    const req = await this.getNoCache('calendar/list-custom-goals')
    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async getMonthlySummary(date: string): Promise<any | boolean> {
    const req = await this.getNoCache(`calendar/get-monthly-summary/${date}`)
    if (!req.success) {
      return false
    }

    return req.res.data.monthlySummary.summaryData
  }

  public async setMonthlySummary(
    date: string,
    data: string,
  ): Promise<any | boolean> {
    const req = await this.post(`calendar/add-monthly-summary/${date}`, {
      summaryData: data,
    })
    if (!req.success) {
      return false
    }

    return true
  }

  public async updateMonthlySummary(
    date: string,
    data: string,
  ): Promise<any | boolean> {
    const req = await this.put(`calendar/update-monthly-summary/${date}`, {
      summaryData: data,
    })
    if (!req.success) {
      return false
    }

    return true
  }

  public async getCausesAndSolutions(
    anomalyDateId: string,
  ): Promise<any | boolean> {
    const req = await this.getNoCache(
      `explain/generate-recommendations/${anomalyDateId}`,
    )

    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async getUserList(): Promise<any> {
    const req = await this.getNoCache(`account/get-user-list`)
    if (!req.success) {
      return null
    }

    return req.res.data
  }

  // public async getUsersLastLogin(userID: string): Promise<any> {
  //   const req = await this.getNoCache(`account/get-last-login/${userID}`)
  //   if (!req.success) {
  //     return null
  //   }

  //   return req.res.data
  // }

  public async getAllUsers(): Promise<any[]> {
    const req = await this.getNoCache('site/get-users')
    if (!req.success) {
      return []
    }

    return req.res.data
  }

  public auditSubscribe(
    handler: (e: any, close: VoidFunction) => void,
    uid: string,
    runningDebug: boolean,
  ): () => void {
    if (!this.getToken()) {
      return (): void => undefined
    }

    let socket: any
    const handleMessage = (event: any, close: VoidFunction): void => {
      const ary = Object.keys(event.testResult).map((key: string): any => ({
        ...event.testResult[key],
        passed: event.testResult[key].testPass,
        definitionMarkdown: event.testResult[key].definition,
        title: event.testResult[key].testDescription,
        solutionMarkdown: event.testResult[key].solution,
        resultMarkdown: event.testResult[key].result,
      }))

      let totalTestsToRun = event.totalTests
      if (event.status === 'COMPLETE') totalTestsToRun = event.numTestsCompleted

      handler(
        {
          currentTestsRan: event.numTestsCompleted,
          percentage: event.percentageComplete,
          tests: ary,
          totalTestsToRun,
        },
        close,
      )
    }

    if (useMock) {
      axios.AuditWebSocket((e: any): void => handleMessage(e, (): void => {}))
    } else {
      socket = io(`${API_BASE_DOMAIN}audit`, {
        transports: ['websocket'],
      })
      socket.on('roomId', ({ roomId }) => {
        socket.emit('join', { roomId })
      })
      socket.on('joined', ({ roomId }): void =>
        socket.emit('runAudit', {
          roomId,
          browserTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          startDate: '90DaysAgo',
          endDate: 'yesterday',
          debug: runningDebug,
          token: this.getToken(),
        }),
      )
      const closeSocket = (): void => {
        if (socket === undefined) return
        socket.close()
        socket.disconnect()
      }

      socket.on('testResult', (e: any): void => handleMessage(e, closeSocket))
    }
    return (): void => {}
  }

  // support
  public async requestAnExpert(form: any): Promise<boolean> {
    const req = await this.post('support/request-an-expert', {
      supportRequest: form,
    })
    if (!req.success) {
      return false
    }

    return true
  }

  public async resetPassword(
    token: string,
    password: string,
  ): Promise<boolean> {
    const req = await this.put(
      `support/reset-password/${token}`,
      {},
      { password },
    )
    if (!req.success) {
      return false
    }

    return true
  }

  public async requestPasswordReset(email: string): Promise<boolean> {
    const req = await this.post('support/forgot-password', { email })
    if (!req.success) {
      return false
    }

    return true
  }

  // settings
  public async addAccount({ form }: { form: any }): Promise<boolean> {
    const req = await this.post('settings/add-ga-account', form)

    if (!req.success) {
      return false
    }

    return true
  }

  public async addUser(form: any): Promise<boolean> {
    const req = await this.post('settings/add-user', form)

    if (!req.success) {
      return false
    }

    return true
  }

  public async removeUser(form: any): Promise<boolean> {
    const req = await this.delete('settings/remove-user', form)

    if (!req.success) {
      return false
    }

    if (req.res.message === 'success') {
      return true
    }

    return false
  }

  public async changeUserPermissions(form: any): Promise<boolean> {
    const req = await this.put('settings/update-user-permissions', form)

    if (!req.success) {
      return false
    }

    if (req.res.message === 'success') {
      return true
    }

    return false
  }

  public async closeAccounts(): Promise<boolean> {
    const req = await this.delete('settings/remove-accounts')

    if (!req.success) {
      return false
    }

    if (req.res.message === 'success') {
      return true
    }

    return false
  }

  public logout(): boolean {
    make.destroyToken()
    window.location.reload()
    return true
  }

  public getCredentials(): boolean {
    return make.getCredentials()
  }

  public setCredentials(credentials): boolean {
    make.setCredentials(credentials)
    return true
  }

  public getDataSource(): boolean {
    return make.getDataSource()
  }

  public setDataSource(credentials): boolean {
    make.setDataSource(credentials)
    return true
  }

  // public async getGaAccounts(credentials: string): Promise<boolean | any> {
  //   const req = await this.getNoCache('settings/ga-accountdata-list', {
  //     params: {
  //       credentials,
  //     },
  //   })
  //   if (!req.success) {
  //     return false
  //   }

  //   return req.res.data
  // }

  public async getAccountSelected(): Promise<boolean | any> {
    const req = await this.getNoCache('account')

    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async getUserDetails(): Promise<boolean | any> {
    const req = await this.getNoCache('user')

    if (!req.success) {
      return false
    }

    return req.res.data
  }

  public async switchAccount(accountID: string): Promise<boolean | any> {
    const req = await this.post('settings/change-current-account', {
      accountID,
    })

    if (!req.success) {
      // TODO: implement when errored
      // Account has not been recognised
      // make.destroyToken()
      // window.location.reload()
      return false
    }

    window.location.reload(true)

    return req.res.data
  }

  public async register(form: RegisterUser): Promise<boolean> {
    try {
      const req = await this.post('settings/register-user', {
        signUpMethod: 'password',
        ...form,
      })

      if (!req.success && req.res.status === 403) {
        return 'This link has expired, please contact your Uplifter administrator to resend the invitation.'
      }

      if (!req.success) {
        return false
      }

      if (req.res.data?.token) {
        this.setToken(req.res.data.token)
        return true
      }

      return req.res.data?.message || req.res.message || false
    } catch (e) {
      return e.response?.data?.message || false
    }
  }

  public async getCampaignCodeGeneratorStructure(): Promise<
    CampaignCodeGeneratorStructure | false
  > {
    const req = await this.getNoCache('code/get-generator')
    if (!req.success) {
      return false
    }

    return req.res.data.generatorConfig
  }

  public async getCampaignCodesByAccount(): Promise<
    CampaignCodesCompressed[] | false
  > {
    const req = await this.getNoCache('code/get-codes-by-account')
    if (!req.success) {
      return false
    }

    return req.res.data.codeList
  }

  public async updateCampaignCodeGeneratorStructure(
    form: any,
  ): Promise<boolean> {
    const req = await this.post('code/update-generator', form)
    if (!req.success) {
      return false
    }

    return true
  }

  public async updateCampaignCodeGeneratorOrder(form: any): Promise<boolean> {
    const req = await this.post('code/update-generator-parameter-order', form)
    if (!req.success) {
      return false
    }

    return true
  }

  public async updateGeneratorParameter(form: any): Promise<boolean> {
    const req = await this.post('code/update-generator-parameter', form)
    if (!req.success) {
      return false
    }

    return true
  }

  public async updateGeneratorParameterSelectDelete(
    form: any,
  ): Promise<boolean> {
    const req = await this.post(
      'code/update-generator-parameter-select-delete-option',
      form,
    )
    if (!req.success) {
      return false
    }

    return req.res.data.updatedField
  }

  public async updateGeneratorParameterSelectUpdate(
    form: any,
  ): Promise<boolean> {
    const req = await this.post(
      'code/update-generator-parameter-select-update-option',
      form,
    )
    if (!req.success) {
      return false
    }

    return req.res.data.updatedOption
  }

  public async updateGeneratorParameterSelectAddOption(
    form: any,
  ): Promise<boolean> {
    const req = await this.post(
      'code/update-generator-parameter-select-add-option',
      form,
    )
    if (!req.success) {
      return false
    }

    return req.res.data.newOption
  }

  public async deleteGeneratorParameter(data: {
    removeId: string
  }): Promise<boolean> {
    const req = await this.post('code/delete-generator-parameter', data)
    if (!req.success) {
      return false
    }

    return true
  }

  public async addGeneratorParameter(
    data: AddGeneratorParameter,
  ): Promise<boolean> {
    const req = await this.post('code/add-generator-parameter', data)
    if (!req.success) {
      return false
    }

    return true
  }

  public async saveCampaignCode(form: SaveCampaignCode): Promise<boolean> {
    const req = await this.post('code/add-code', { ...form })
    if (!req.success) {
      return false
    }

    return true
  }

  public async saveCampaignCodes(form: SaveCampaignCodes): Promise<boolean> {
    const req = await this.post('code/add-codes', { ...form })
    if (!req.success) {
      return false
    }

    return true
  }

  public async getPreviousGeneratedCodes({
    startDate,
    endDate,
  }: {
    startDate?: string
    endDate?: string
  }): Promise<false | CampaignCodes[]> {
    const req = await this.getNoCache('code/get-codes-by-account', {
      params: { startDate, endDate },
    })
    if (!req.success) {
      return false
    }

    return req.res.data.codeList
  }

  public async getBatchPreviousGeneratedCodes({
    startDate,
    endDate,
  }: {
    startDate?: string
    endDate?: string
  }): Promise<false | CampaignCodes[]> {
    const req = await this.getNoCache('code/get-batch-codes-by-account', {
      params: { startDate, endDate },
    })
    if (!req.success) {
      return false
    }
    const { codeList, queryTotal } = req.res.data
    return { codeList, queryTotal }
  }

  public async getBatchQueryAsync(batch: any): Promise<any | false> {
    const req = await this.post('code/batch-query', {
      batch,
    })
    if (!req.success) {
      return false
    }
    return req.res.data.codeList
  }

  public async getUsersPreviousGeneratedCodes({
    startDate,
  }: {
    startDate?: number
  }): Promise<false | CampaignCodes[]> {
    const req = await this.getNoCache('code/get-codes-by-user', {
      params: {
        startDate,
      },
    })
    if (!req.success) {
      return false
    }

    return req.res.data.codeList
  }

  public async getBatchUsersPreviousGeneratedCodes(): Promise<
    false | CampaignCodes[]
  > {
    const req = await this.getNoCache('code/get-batch-codes-by-user')
    if (!req.success) {
      return false
    }
    return req.res.data.codeList
  }

  public async getAAFTPDetails(): Promise<boolean> {
    const req = await this.getNoCache('code/get-AA-FTP-details')
    if (!req.success) {
      return false
    }
    return req.res.data
  }

  public async updateAAFTPDetails(details: FTPDetails): Promise<boolean> {
    const req = await this.put('code/update-AA-FTP-details', details)
    if (!req.success) {
      return false
    }

    return true
  }

  public async updateCampaignCode(
    form: CampaignCodesCompressed,
  ): Promise<boolean> {
    const req = await this.put('code/update-code', form)
    if (!req.success) {
      return false
    }

    return true
  }

  public async generateSaintFile(): Promise<boolean> {
    const req = await this.getNoCache('code/generate-saint-file')
    if (!req.success) {
      return false
    }

    return true
  }

  public async deleteCampaignCodes(data: string[]): Promise<boolean> {
    const postData = {
      codeList: data,
    }
    const req = await this.post(`code/delete-codes`, postData)

    if (!req.success) {
      return false
    }

    return true
  }
}

export default new ApiClient()
